var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('TrackingNoscript'),_vm._v(" "),_c('homepage-header'),_vm._v(" "),_c('v-main',{staticClass:"mastcontent"},[_c('Nuxt',{attrs:{"keep-alive":""}})],1),_vm._v(" "),(!_vm.isBusy)?_c('Transition',{attrs:{"name":"fade"}},[_c('page-footer')],1):_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }